import React from "react";

import "@Features/groups/ui/main.scss";

import { GroupsProvider } from "./state/provider";
import GroupsList from "@Totum/Groups/UI/components/GroupsList";
import GroupsInspector from "@Totum/Main/Components/groups/GroupsInspector";

const GroupsPageLayout = () => {
    return (
        <GroupsProvider>
            <div className="groups-page">
                <div style={{ width: "50%" }}>
                    <GroupsList key="groups-view-desktop" />
                </div>
                <div style={{ width: "50%" }}>
                    <GroupsInspector key={"groups-inspector"} />
                </div>
            </div>
        </GroupsProvider>
    );
};

export default GroupsPageLayout;
